'use es6';

import { Component } from 'react';
import { path } from 'rich-text-lib/utils/iterables';
import { isHubSpotUI } from '../utils/dom';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withPropagationOverride(namespace) {
  const isHubSpotUIWithNamespace = isHubSpotUI(namespace);
  return WrappedComponent => {
    const stopPropagation = path(['Event', 'prototype', 'stopPropagation'], window);
    const jQueryStopPropagation = path(['jQuery', 'Event', 'prototype', 'stopPropagation'], window);
    const overrideStopPropagation = function overrideStopPropagation() {
      if (isHubSpotUIWithNamespace(this.target)) {
        return;
      }
      stopPropagation.apply(this);
    };
    const overrideJQueryStopPropagation = function overrideJQueryStopPropagation() {
      if (isHubSpotUIWithNamespace(this.target)) {
        return;
      }
      jQueryStopPropagation.apply(this);
    };
    return class WithPropagationOverride extends Component {
      componentDidMount() {
        Event.prototype.stopPropagation = overrideStopPropagation;
        if (jQueryStopPropagation) {
          window.jQuery.Event.prototype.stopPropagation = overrideJQueryStopPropagation;
        }
      }
      componentWillUnmount() {
        Event.prototype.stopPropagation = stopPropagation;
        if (jQueryStopPropagation) {
          window.jQuery.Event.prototype.stopPropagation = jQueryStopPropagation;
        }
      }
      render() {
        return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
      }
    };
  };
}